import { createContext } from "@-/com.npmjs.use-context-selectors";
import { defaultError } from "@-/com.npmjs.react-context-default-error";
import type { MorphemeMnemonicsPanelContextValue } from "#morpheme-mnemonics-panel-context-value";

export const MorphemeMnemonicsPanelContext = createContext(
  defaultError<MorphemeMnemonicsPanelContextValue>("MorphemeMnemonicsPanelContext"),
);
